import fittingsData from '../fittingsData';
import { extractDnFromFlangeKey, getPipeDiameterForDn } from './collectorUtils';

/**
 * Полная высота гидроразделителя (корпус + верх/низ), как в HydraulicSeparatorEditor.
 *
 * @param {object} config
 * @param {number} config.bodyHeight — высота корпуса (calculatedSeparatorHeight или ручная)
 * @param {number} config.mainPipeDiameter
 * @param {boolean} [config.hasTopConnection]
 * @param {string} [config.topCapFitting]
 * @param {number|null} [config.topCapFittingLength]
 * @param {boolean} [config.hasBottomConnection]
 * @param {string} [config.bottomCapFitting]
 * @param {number|null} [config.bottomCapFittingLength]
 * @param {boolean} [config.hasTopCap]
 * @param {string} [config.topCapType]
 * @param {boolean} [config.hasBottomCap]
 * @param {string} [config.bottomCapType]
 * @param {(fittingId: string, fittingLength: number|null|undefined) => number} resolveFittingLength
 */
export function computeHydraulicSeparatorTotalHeight(config, resolveFittingLength) {
  const {
    bodyHeight = 0,
    mainPipeDiameter = 0,
    hasTopConnection,
    topCapFitting,
    topCapFittingLength,
    hasBottomConnection,
    bottomCapFitting,
    bottomCapFittingLength,
    hasTopCap,
    topCapType,
    hasBottomCap,
    bottomCapType,
  } = config;

  let totalHeight = Number(bodyHeight) || 0;

  const isFlangeWithSmallerDiameter = (fittingId) => {
    if (!fittingId?.startsWith('Flanec_')) return false;
    const flangeDn = extractDnFromFlangeKey(fittingId);
    const flangePipeDiameter = getPipeDiameterForDn(flangeDn);
    return flangePipeDiameter && flangePipeDiameter < mainPipeDiameter;
  };

  const isFlangeWithSameDiameter = (fittingId) => {
    if (!fittingId?.startsWith('Flanec_')) return false;
    const flangeDn = extractDnFromFlangeKey(fittingId);
    const flangePipeDiameter = getPipeDiameterForDn(flangeDn);
    return flangePipeDiameter && Math.abs(flangePipeDiameter - mainPipeDiameter) < 0.1;
  };

  if (hasTopConnection && topCapFitting) {
    if (!isFlangeWithSameDiameter(topCapFitting)) {
      totalHeight += resolveFittingLength(topCapFitting, topCapFittingLength);
    }
  }

  if (hasBottomConnection && bottomCapFitting) {
    if (!isFlangeWithSameDiameter(bottomCapFitting)) {
      totalHeight += resolveFittingLength(bottomCapFitting, bottomCapFittingLength);
    }
  }

  const hasTopFlangeSmaller =
    hasTopConnection && isFlangeWithSmallerDiameter(topCapFitting);
  const hasBottomFlangeSmaller =
    hasBottomConnection && isFlangeWithSmallerDiameter(bottomCapFitting);

  if (hasTopCap && topCapType === 'elliptical' && !hasTopFlangeSmaller) {
    const capData = fittingsData[`Zaglushka_EL_${mainPipeDiameter}`];
    if (capData) {
      totalHeight += capData.length;
    }
  }

  if (hasBottomCap && bottomCapType === 'elliptical' && !hasBottomFlangeSmaller) {
    const capData = fittingsData[`Zaglushka_EL_${mainPipeDiameter}`];
    if (capData) {
      totalHeight += capData.length;
    }
  }

  return Math.round(totalHeight);
}

/** Габарит для упаковки, «25кг/2м» и обрешётки: max(горизонталь, полная высота ГР). */
export function getDrawingGabaritMm(metadata) {
  if (!metadata) return 0;
  const horizontal = Number(metadata.totalLength) || 0;
  const separatorHeight = Number(metadata.separatorTotalHeight) || 0;
  return Math.max(horizontal, separatorHeight);
}
